import { useEffect, useState } from 'react';
import type { RefCallback } from 'react';

type UseFocusInputs = {
  emailInputRef: RefCallback<HTMLInputElement>;
  passwordInputRef: RefCallback<HTMLInputElement>;
};

/**
 * Hook which manages focusing the correct input at the correct time.
 */
const useFocusInputs = (): UseFocusInputs => {
  //  Track the inputs in state via callback refs, which will be passed to AuthForm.(EmailInput | PasswordInput),
  //  so the effect below re-runs whenever an input mounts or unmounts.
  const [emailInput, emailInputRef] = useState<HTMLInputElement | null>(null);
  const [passwordInput, passwordInputRef] = useState<HTMLInputElement | null>(null);

  useEffect(() => {
    //  If there is just an email input, focus it.
    if (emailInput && !passwordInput) {
      emailInput.focus();
      //  Otherwise, if there is a password input, we always want to focus it.
    } else if (passwordInput) {
      passwordInput.focus();
    }
  }, [
    emailInput,
    passwordInput,
  ]);

  return {
    emailInputRef,
    passwordInputRef,
  };
};

export default useFocusInputs;
